export const MIN_SCALE = 0.1;
export const MAX_SCALE = 4;
export const SCALE_MODIFIER = 1.25;
